jQuery(document).ready(function () {
    if ( jQuery(".case-studies.filtered").length) {
        jQuery("html, body").animate({
            scrollTop: jQuery('.filter-inline form').offset().top - 150
        }, 1000);
    }
});